import { render, staticRenderFns } from "./EventDelivery.vue?vue&type=template&id=3b1561e9&"
import script from "./EventDelivery.vue?vue&type=script&lang=js&"
export * from "./EventDelivery.vue?vue&type=script&lang=js&"
import style0 from "./EventDelivery.vue?vue&type=style&index=0&id=3b1561e9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports